import { render, staticRenderFns } from "./ExternalBookingRooms.vue?vue&type=template&id=67979e2a&scoped=true"
import script from "./ExternalBookingRooms.vue?vue&type=script&lang=js"
export * from "./ExternalBookingRooms.vue?vue&type=script&lang=js"
import style0 from "./ExternalBookingRooms.vue?vue&type=style&index=0&id=67979e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67979e2a",
  null
  
)

export default component.exports